<template>
  <div class="payrollImport">
    <v-form v-model="isFormValid" ref="form" class="mt-4" lazy-validation>
      <v-row>
        <v-col cols="4" :style="{ 'max-width': '400px' }">
          <div>
            <v-select
              v-model="payrollToImport"
              label="Payroll to import"
              :items="payrollToImportList"
              item-text="Text"
              item-value="Text"
              :rules="rules"
              :loading="isLoadingPayrolls"
              outlined
              dense
            ></v-select>
          </div>

          <div>
            <DatePicker v-model="payrollDate" label="Payroll date" :rules="rules" />
          </div>

          <div>
            <v-file-input
              v-model="payrollFile"
              ref="file"
              label="Import file"
              accept=".csv, text/plain, .tab"
              :rules="rules"
              dense
            ></v-file-input>
          </div>
        </v-col>
      </v-row>
    </v-form>

    <AutomatedTasks processType="Payroll Import" :counter="counter" />

    <v-footer padless fixed outlined class="pl-5 pr-5 pt-3 pb-3" color="white" elevation="3">
      <v-spacer></v-spacer>

      <v-btn color="primary" depressed :loading="isLoadingPayrollProcess" @click="startPayroll">
        Start payroll
      </v-btn>
    </v-footer>
  </div>
</template>

<script>
import DatePicker from '@/components/formControls/DatePicker.vue';
import AutomatedTasks from './AutomatedTasks.vue';

export default {
  name: 'PayrollImport',
  components: { DatePicker, AutomatedTasks },

  data() {
    return {
      isFormValid: false,
      isLoadingPayrolls: false,
      payrollToImport: null,
      payrollDate: new Date().toISOString(),
      payrollFile: null,
      payrollToImportList: [],

      isLoadingPayrollProcess: false,

      rules: [(v) => !!v || 'Required.'],

      counter: 0,
    };
  },

  computed: {
    currentPlanId() {
      return this.$store.getters.currentPlanId;
    },
  },

  watch: {
    currentPlanId() {
      if (this.currentPlanId) this.getImportDefifnitionList();
    },
  },

  mounted() {
    if (this.currentPlanId) this.getImportDefifnitionList();
  },

  methods: {
    startPayroll() {
      this.isFormValid = this.$refs.form.validate();
      if (!this.isFormValid) return;

      let data = new FormData();
      data.append('PlanId', this.currentPlanId);
      data.append('PayrollName', this.payrollToImport);
      data.append('PayrollDate', this.payrollDate);
      data.append(
        'File',
        new Blob([this.payrollFile], {
          type: this.payrollFile.type,
        })
      );

      this.startPayrollProcess(data);
    },

    async getImportDefifnitionList() {
      this.isLoadingPayrolls = true;

      try {
        const response = await this.$api.get(
          `/Import/GetImportDefinitionList?planId=${this.currentPlanId}&importType=Monthly Payroll`
        );

        this.payrollToImportList = response.data;
      } catch (error) {
        console.log(error.message);
      } finally {
        this.isLoadingPayrolls = false;
      }
    },

    async startPayrollProcess(importData) {
      this.isLoadingPayrollProcess = true;

      try {
        await this.$api({
          url: '/Automation/StartPayrollProcess',
          method: 'POST',
          data: importData,
        });

        this.$store.commit('setNotificationMessage', {
          type: 'success',
          text: 'Payroll import has been started',
        });
        this.payrollToImport = null;
        this.payrollDate = new Date().toISOString();
        this.payrollFile = null;
      } catch (error) {
        console.log(error.message);
      } finally {
        this.isLoadingPayrollProcess = false;
        this.counter += 1;
      }
    },
  },
};
</script>

<style lang="scss">
.payrollImport {
  margin-bottom: 20px;
  padding-left: 30px;
  padding-right: 30px;
  .v-data-table tbody tr {
    cursor: default;
  }
}
</style>
